/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Shower(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M72,228a12,12,0,1,1-12-12A12,12,0,0,1,72,228Zm16-40a12,12,0,1,0,12,12A12,12,0,0,0,88,188Zm-60-4a12,12,0,1,0,12,12A12,12,0,0,0,28,184Zm40-16a12,12,0,1,0-12,12A12,12,0,0,0,68,168ZM248,32H219.31348A15.89354,15.89354,0,0,0,208,36.68652L180.15576,64.53027,54.01855,85.55322a16.00028,16.00028,0,0,0-8.6831,27.09619l98.01514,98.01465a15.99969,15.99969,0,0,0,27.09619-8.68261l21.023-126.13721v-.00049L219.31348,48H248a8,8,0,0,0,0-16Z" />
    </Svg>
  );
}

export default Shower;
